export * from './characteristic-collection.model';
export * from './characteristic-type-name.enum';
